// extracted by mini-css-extract-plugin
export default {"cardContainer":"card_cardContainer__yWynn"};